import {
  formatDateTimeInTimeZone,
  getCurrentDateInTimeZone,
  parseDateTimeStringInTimeZone
} from '@viveaesthetics/elemy-shared-core/lib/utils/date'
import { subHours } from 'date-fns'

import { ProviderTimeSlot } from '@/hooks/provider/useGetProvidersAvailableWindowByDay'

const DEFAULT_TIME_SLOT_DURATION_HOURS = 1
export const getNextAvailableSlotSinceDate = (
  timeSlots: ProviderTimeSlot[],
  sinceDate = new Date(),
  timeSlotDurationHours = DEFAULT_TIME_SLOT_DURATION_HOURS
) => {
  return timeSlots.find(timeSlot => {
    const timeSlotDate = subHours(
      new Date(timeSlot.endTime),
      timeSlotDurationHours
    )
    return timeSlotDate > sinceDate
  })
}

export interface GroupedByDaySlotsForProvider {
  date: string
  times: ProviderTimeSlot[]
}

export const getVisibleSlotsForProvider = (
  timeSlots: ProviderTimeSlot[],
  timeZone: string
): GroupedByDaySlotsForProvider[] => {
  const now = getCurrentDateInTimeZone(timeZone)
  const groupedTimes = timeSlots.reduce<Record<string, ProviderTimeSlot[]>>(
    (acc, timeSlot) => {
      const dateObj = parseDateTimeStringInTimeZone(
        timeSlot.startTime,
        timeZone
      )
      if (dateObj < now) {
        return acc
      }
      const dateKey = formatDateTimeInTimeZone(dateObj, timeZone, 'E, MMM d')
      if (!acc[dateKey]) {
        acc[dateKey] = []
      }
      acc[dateKey].push(timeSlot)
      return acc
    },
    {}
  )
  const visibleTimes = Object.entries(groupedTimes)
    .sort(([dateA], [dateB]) => {
      return (
        parseDateTimeStringInTimeZone(dateA, timeZone).getTime() -
        parseDateTimeStringInTimeZone(dateB, timeZone).getTime()
      )
    })
    .slice(0, 3)
    .map(([date, times]) => ({
      date,
      times
    }))
  return visibleTimes
}
